import Vue from 'vue';
import Vuex from 'vuex';
import ls from 'local-storage';
import request from '@/assets/js/request';
import {Message} from 'element-ui';
import {getUserInfo, enterpriseStatus} from '@/api/user';
import {getUserInfoToken} from '@/api/trend';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo: null, // 用户信息
        sign: '', // 请求sign
        permissions: [], // 后台权限
        verify: null, //认证信息
        config: null, //页面配置信息
        helpMenus: null, //帮助中心菜单
        whiteFlag: false, // 实验功能白名单用户  0:否，1:是
        msgNum: '', //系统消息数量
        userData: null, // 用户所有数据
        enterpriseCertify: null, // 企业认证信息
        userType: null, // 用户类型 1：个人 3：企业
        trendConfig: null, // 数据中心配置
        verificationPlatform: 2, // 验证平台 2：法大大 1：电子签
    },
    mutations: {
        SET_VERIFY(state, data) {
            state.verify = data;
            ls.set('verify', data);
        },
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo || null;
        },
        SET_TREND_CONFIG(state, trendConfig) {
            state.trendConfig = trendConfig;
        },
        SET_USERINFO(state, data) {
            ls.set('userData', data);

            const {idType, sign, invitaionCodeFrom, userInfo, whiteFlag, fddSignStatus, isVerify, regStep, cpOrgVipVO, alipayStatus, bankStatus} =
                data || {};
            state.sign = sign;
            ls.set('sign', sign);

            // 设置用户信息
            if (invitaionCodeFrom) userInfo.invitaionCodeFrom = invitaionCodeFrom;
            state.userInfo = userInfo || null;
            state.whiteFlag = whiteFlag || 0; // 是否是特定菜单白名单

            // 设置认证平台
            state.verificationPlatform = userInfo.verifyService || 2;

            // 设置个人认证信息
            const verifyInfo = {
                fddSignStatus, //
                isVerify, // 是否认证成功
                regStep, // 个人升级步骤
                vip: cpOrgVipVO, // 合同签署信息和购买的VIP信息
                canExperienceRelease: data.canExperienceRelease || 0, // 是否试用过免费单曲
                alipayStatus, // 支付宝状态
                bankStatus, // 银行状态
            };
            state.verify = verifyInfo;
            state.userData = data; // 设置用户源数据信息

            // 设置用户类型
            state.userType = idType;
        },
        SET_ENTERPRISE_CERTIFY(state, data) {
            // 新增企业数据
            const {
                upgradeStep,
                upgradeAuthType = 0,
                enterpriseUpgradeFlag,
                licenceLegalPersonNumber,
                licenceLegalPersonName,
                telephone,
                licenceEnterpriseName,
                upgradeBusinessLicencePhoto,
                licenceNumber,
                entAccountName,
                entBankBranchName,
                entBankCard,
                entBankHeadName,
                entBankCode,
                upgradeEntrustPhoto,
                entBankHeadCode,
            } = data || {};
            const enterpriseCertify = {
                upgradeStep, // 升级步骤 -1:认证失败; 0:默认; 1:企业资质校验; 2:企业认证短信提交; 3:委托书提交; 4:对公账户信息提交; 5:打款回填信息提交; 6:认证完成;
                upgradeAuthType, // 升级认证类型 0:未选择; 1:法人; 2:代理人 3:个体户企业
                enterpriseUpgradeFlag, //  0:不需要升级 1:升级中 2:升级完成
                telephone, // 用户手机号
                licenceLegalPersonName, // 法人姓名
                licenceLegalPersonNumber, // 法人身份证
                licenceEnterpriseName, // 企业名称
                upgradeBusinessLicencePhoto, // 营业执照
                licenceNumber, // 社会统一码
                entAccountName, // 对公账户名
                entBankBranchName, // 企业开户支行名称
                entBankCode, // 企业开户行支行code
                entBankCard, // 对公账号
                entBankHeadName, // 企业开户总行名称
                entBankHeadCode, // 企业开户总行code
                upgradeEntrustPhoto, // 企业账号升级时委托书图片
            };
            state.enterpriseCertify = enterpriseCertify;
        },
        SET_CONFIG(state, data) {
            state.config = data;
            ls.set('config', data);
        },
        LOGOUT(state) {
            ['sign', 'permissions', 'userInfo', 'verify', 'userData'].forEach((key) => {
                state[key] = null;
                ls.remove(key);
            });
        },

        SET_HELP_MENUS(state, data) {
            state.helpMenus = data;
        },
        SET_MSG_NUM(state, data) {
            state.msgNum = data;
        },
    },
    actions: {
        //获取页面配置信息
        getBaseConfig({commit}) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await request({
                        url: '/common/config',
                        method: 'POST',
                        params: {},
                    });
                    const {result, msg} = response.data;
                    if (!response.data.state) return Message.error(msg || '获取系统信息失败');
                    commit('SET_CONFIG', result || null);
                    const _config = Object.keys(result || {});
                    _config.forEach((item) => {
                        Vue.set(Vue.prototype, '$' + item, result[item]);
                    });
                    resolve(result);
                } catch (error) {
                    reject(false);
                    console.error(error);
                }
            });
        },
        // 获取企业认证信息
        async getEnterpriseCertify({commit, state}, forcedUpdate = false) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                try {
                    if (state.userType == 3 && forcedUpdate == false) return resolve({});
                    if (state.enterpriseCertify && forcedUpdate == false) return resolve(state.enterpriseCertify);
                    const response = await enterpriseStatus();
                    const {result, msg} = response.data;
                    if (!response.data.state) return Message.error(msg || '获取企业升级信息失败');
                    commit('SET_ENTERPRISE_CERTIFY', result || null);
                    resolve(result);
                } catch (error) {
                    reject(false);
                    console.error(error);
                }
            });
        },
        //获取用户信息
        async getUserInfo({commit}) {
            try {
                const response = await getUserInfo();
                const {state, result, msg} = response.data;
                if (!state) return Message.error(msg || '获取用户信息失败');
                // 原有的用户数据
                commit('SET_USERINFO', result || null);
            } catch (error) {
                console.error(error);
            }
        },
        // 获取数据中心token
        async getTrendConfig({commit}) {
            const response = await getUserInfoToken();
            const {state, result, msg} = response.data;
            if (!state) return Message.error(msg || '获取数据中心token异常');
            const {mainCpId, subsystem, token, sonCpId, siteId, domainUrl} = result || {};
            commit('SET_TREND_CONFIG', {mainCpId, subsystem, token, sonCpId, siteId, domainUrl});
        },
        //获取帮助中心菜单
        async getHelpMenus({commit}) {
            try {
                const response = await request({ url: '/faq/cp_faq/view/menus', method: 'POST' });
                const { state, msg, result } = response.data;
                if (!state) return Message.error(msg || '获取帮助中心菜单失败');

                const helpMenus = result.map((item) => ({
                    id: item.id,
                    name: item.title,
                    link: item.pageUrl.replace('/#', ''),
                    child: (item.subFaqMenus || []).map((subItem) => ({
                        id: subItem.id,
                        name: subItem.title,
                        link: subItem.pageUrl.replace('/#', ''),
                    })),
                }));
                commit('SET_HELP_MENUS', helpMenus);
            } catch (error) {
                console.error('获取帮助中心菜单失败:', error);
            }
        },
    },
    modules: {},
    getters: {
        // 是否允许专辑创建
        isAlbumCreate: (state) => {
            const {userInfo} = state;
            if (userInfo.albumSwitch && userInfo.albumSwitch == 1) return userInfo.cpAlbumReason;
            return '';
        },
        /**
         * 企业升级当前进度
         * @returns {Number} step 进度条显示步骤
         * @returns {Number} pageStep 跳转页面的下标
         */
        enterpriseUpgradeStep: (state) => {
            const {upgradeStep, upgradeAuthType} = state.enterpriseCertify || {};
            if (upgradeAuthType == 1) {
                if (upgradeStep == 0) return {step: 0, pageStep: 1}; // 企业资质提交
                if (upgradeStep == 1) return {step: 1, pageStep: 2}; // 短信认证
                if (upgradeStep == 6 || upgradeStep == -1 || upgradeStep == 2) return {step: 4, pageStep: 6}; // 认证失败 || 认证完成
            }
            if (upgradeAuthType == 2) {
                if (upgradeStep == 0) return {step: 0, pageStep: 1}; // 企业资质提交
                if (upgradeStep == 1) return {step: 1, pageStep: 3}; // 对公账户信息提交
                if (upgradeStep == 3) return {step: 2, pageStep: 4}; // 委托书提交
                if (upgradeStep == 4) return {step: 3, pageStep: 5}; // 打款回填信息提交
                if (upgradeStep == 5 || upgradeStep == 6 || upgradeStep == -1) return {step: 4, pageStep: 6}; // 认证失败 || 认证完成
            }
            if (upgradeAuthType == 3) {
                if (upgradeStep == 0) return {step: 0, pageStep: 7}; // 企业资质提交
                if (upgradeStep == 6 || upgradeStep == -1 || upgradeStep == 1) return {step: 1, pageStep: 6}; // 认证失败 || 认证完成
            }
            return {step: 0, pageStep: 0};
        },
        // 是否允许企业升级
        isEnterpriseUpgrade: (state) => {
            const {enterpriseUpgradeFlag} = state.enterpriseCertify || {};
            return enterpriseUpgradeFlag == 1 ? true : false;
        },
        // 企业升级类型 1：法人 2：代理人
        enterpriseUpgradeType: (state) => {
            const {upgradeAuthType} = state.enterpriseCertify || {};
            return upgradeAuthType;
        },
        // 用户认证信息
        certifyInfo: (state) => {
            const {
                licenceLegalPersonName,
                licenceLegalPersonNumber,
                upgradeBusinessLicencePhoto,
                licenceEnterpriseName,
                licenceNumber,
                entAccountName,
                entBankBranchName,
                entBankCard,
                entBankHeadName,
                upgradeEntrustPhoto,
                entBankCode,
                entBankHeadCode,
            } = state.enterpriseCertify || {};
            return {
                corporateName: licenceLegalPersonName || '',
                corporateIdCard: licenceLegalPersonNumber || '',
                entLicenceFile: upgradeBusinessLicencePhoto || '',
                entName: licenceEnterpriseName || '',
                entQualificationNum: licenceNumber || '',
                entAccountName: entAccountName || licenceEnterpriseName,
                entBankBranchOfficeName: entBankBranchName || '',
                entBankCode: entBankCode || '',
                entBankCard: entBankCard || '',
                entBankHandOfficeName: entBankHeadName || '',
                entBankHeadCode: entBankHeadCode || '',
                enTrustPhotoPath: upgradeEntrustPhoto || '',
            };
        },
        isWithdraw: (state) => {
            const {bankStatus = 0, alipayStatus = 0} = state.verify || {};
            if (bankStatus == 1 || alipayStatus == 1) return true;
            return false;
        },
        // 去哪里签署合同
        goContractSigned: (state) => {
            const {userType} = state;
            const {vip} = state.verify || {};
            const {isContractSigned = 0} = vip || {};
            if (userType == 1 && isContractSigned == 0) return '/manage/contract/verify/fdd/step/2';
            if (userType == 3 && isContractSigned == 0) return '/manage/contract/enterprise/fdd/signContract';
            return '';
        },
        userState: (state) => {
            const {canExperienceRelease = 0, vip, isVerify = 0} = state.verify || {};
            const {isContractSigned = 0, isPaid = 0, isExpired = 0, isPersonContractSigned = 0} = vip || {};
            // 未认证
            if (isVerify == 0) return 1;
            // 未签约 isContractSigned 是否签署合同  isPersonContractSigned 表示是否签署过个人合同
            if (isContractSigned == 0 || (isPersonContractSigned == 1 && isContractSigned == 0)) return 2;
            // 是否试用 4：已试用单曲  3：未试用
            if (isPaid == 0) return canExperienceRelease ? 3 : 4;
            // 已过期的付费用户
            if (isExpired == 1 && isPaid == 1) return 5;
            // 正常的VIP用户
            if (isExpired == 0 && isPaid == 1) return 6;
        },
    },
});
